import {FC} from 'react';
import useTypedSelector from '../../../../common/useTypedSelector';
import {ItemType} from '../../../../graphql/generated/types';
import {useSelectItem} from '../../../../pagewebLayout/useSelectItem';
import {CommonItemProps} from '../../type';
import {Hidden} from '../Hidden';
import {Banner} from './Banner';
import {CardView} from './CardView';
import {CleanView} from './CleanView';
import {Da} from './Da';
import {EventBanner} from './EventBanner';
import {LineBanner} from './LineBanner';
import {More} from './More';
import {NormalListView} from './NormalListView';
import {OnAir} from './OnAir';
import {PosterView} from './PosterView';
import {PromotionBanner} from './PromotionBanner';
import {PromotionCardView} from './PromotionCardView';
import {RankingListView} from './RankingListView';
import {SingleListView} from './SingleListView';
import {StandaloneBanner} from './StandaloneBanner';
import {StrategyCategory} from './StrategyCategory';

function Item({id, groupId}: {id: string; groupId: string}) {
  const {item} = useSelectItem(id);
  const parentGroup = useTypedSelector(
    state => state.pagewebLayout.entities.groups[groupId]
  );
  const parentSection = useTypedSelector(
    state =>
      state.pagewebLayout.entities.sections[
        state.pagewebLayout.relations.groups[groupId].parentId
      ]
  );
  const ChoosedComponent =
    !item.type || !layoutItemTypeComponentMap[item.type]
      ? Hidden
      : layoutItemTypeComponentMap[item.type];

  return (
    <ChoosedComponent
      item={item}
      parentGroup={parentGroup}
      parentSection={parentSection}
    />
  );
}

const layoutItemTypeComponentMap: {
  [key in ItemType]: FC<CommonItemProps>;
} = {
  [ItemType.Banner]: Banner,
  [ItemType.EventBanner]: EventBanner,
  [ItemType.LineBanner]: LineBanner,
  [ItemType.PromotionBanner]: PromotionBanner,
  [ItemType.RankingCardView]: CardView,
  [ItemType.CardView]: CardView,
  [ItemType.CleanView]: CleanView,
  [ItemType.NormalListView]: NormalListView,
  [ItemType.SingleListView]: SingleListView,
  [ItemType.RankingListView]: RankingListView,
  [ItemType.RankingPosterView]: PosterView,
  [ItemType.Da]: Da,
  [ItemType.PosterView]: PosterView,
  [ItemType.StrategyView]: StrategyCategory,
  [ItemType.More]: More,
  [ItemType.StandaloneBanner]: StandaloneBanner,
  [ItemType.PromotionCardView]: PromotionCardView,
  [ItemType.OnAir]: OnAir,
  [ItemType.Unknown]: Hidden,
};

export default Item;
